let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("573g9")).then(() => parcelRequire('95BjK'));